import { CacheModule } from "@/services/cacheModule";
import { VIDEO_URL_CACHE } from "@/utils/nativeStorage/local_keys";

class VideoUrlCache extends CacheModule {
  constructor() {
    super(VIDEO_URL_CACHE, {});
  }
}
export default new VideoUrlCache();
